<template>
  <section class="book__slider">
    <div v-if="sliderData" class="book__slider__section">
      <VueSlickCarousel v-bind="settings" class="slider">
        <div v-for="(item, index) in sliderData" :key="index"  class="sliderItem">
          <router-link target="_blank" class="sliderRouter" :to="`/bookdetail/${item.id}/${item.title}`">
          <img :src="item.image" :alt="item.title" />
          <p>{{item.title }}</p>
          </router-link>
        </div>
      </VueSlickCarousel>
    </div>
  </section>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  props:
    {sliderData:Array}
    ,
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 943,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 741,
            settings: {
              slidesToShow:2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow:1,
              slidesToScroll: 1,
            }
          }
        ]
      }
    };
  }
};
</script>
<style>
.slick-prev:before, .slick-next:before{
  color:#e48325 !important;
}
@media screen and (max-width:500px){
  .imageSlider{
    width:60%;
    object-fit:fill;
    height:auto;
  }
}
  .sliderItem{
        justify-content: center;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    
  }
  .sliderItem img{
    width:100%;
    padding: 5px;
    height:50vh;

 }
 .sliderRouter {
   color:black;
     justify-content: center;
    display: flex !important;
    flex-direction: column;
    align-items: center;
 }
 .sliderRouter:hover{
   color:black;
    }

</style>
